import { render, staticRenderFns } from "./editScheme.vue?vue&type=template&id=62144a34&scoped=true&"
import script from "./editScheme.vue?vue&type=script&lang=js&"
export * from "./editScheme.vue?vue&type=script&lang=js&"
import style0 from "./editScheme.vue?vue&type=style&index=0&id=62144a34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62144a34",
  null
  
)

export default component.exports